import { useEffect, useLayoutEffect, useState } from "react"
import { useSelector } from "react-redux"
import { AssistanceToResolveScreen } from "../../screen/AssistanceToResolveScreen"
import { useAssistanceResolve } from "../../core/utils/hooks/useAssistanceResolve"
import { useFormProject } from "../../core/utils/hooks/useFormProject"
import Send from "../../core/communication"
import { customToast } from "../../components/Toast"
import { blobToBase64, sendFileToFirebase } from "../../core/utils/hooks/uploadItem"
import { useLocation, useNavigate } from "react-router-dom"
import { useForm } from "react-hook-form"
import { useScope } from "../SelectProjectCompanyContainer"
import { useAssistanceTags } from "../../core/utils/hooks/useTags"

const setDefaultData = (inputData) => {
  if (!inputData || !inputData.fields) return {};

  let defaultValue = {};
  const hasFilledData = inputData.fields.some(obj => obj.hasOwnProperty("filledData"));

  if (hasFilledData) {
    inputData.fields.forEach(element => {
      const { id, type, filledData } = element;
      if (!filledData || !filledData.value) return;

      if (type === "radio" || type === "users" || type === "select") {
        defaultValue[id] = [{ ...filledData, label: filledData.value, questionId: id }];
      } else if (type === "checkbox") {
        const splitValues = filledData.value.split("|");
        defaultValue[id] = splitValues.map(value => ({ value, label: filledData.value, questionId: id }));
      } else {
        defaultValue[id] = filledData.value;
      }
    });
  }

  return defaultValue;
};

const getDefaultData = (filledData, valuesQuestions, reset) => {
  if (!filledData || Object.keys(filledData).length === 0) return;

  const defaultDataKeys = Object.keys({ ...filledData, ...valuesQuestions });
  const valuesQuestionKeys = Object.keys(valuesQuestions);

  const updatedList = defaultDataKeys.filter(key => valuesQuestionKeys.includes(key));

  updatedList.forEach(id => {
    const value = valuesQuestions[id];
    const isPipe = value?.includes("|");

    const splitValuesWithPipe = () => {
      const splitValues = value.split("|");
      filledData[id] = splitValues.map(sv => ({ value: sv, label: sv }));
    };

    const defaultValues = () => {
      filledData[id] = [{ value: value, label: value }];
    };

    if (Array.isArray(filledData[id])) {
      if (isPipe) {
        splitValuesWithPipe();
      } else if (typeof value === "string") {
        filledData[id] = value || "";
      } else {
        defaultValues();
      }
    } else {
      if (isPipe) {
        splitValuesWithPipe();
      } else if (typeof value === "string") {
        filledData[id] = value || "";
      } else {
        defaultValues();
      }
    }
  });

  reset(filledData);
};


const AssistanceToResolveContainer = () => {
  const { scope } = useScope()
  const navigate = useNavigate()
  const location = useLocation()
  const { users, user } = useSelector((state) => state.app)
  const { forms: formsByProject } = useFormProject()
  const { dataResolve, setReload, loadingDataToResolve } = location?.state || useAssistanceResolve()
  const { tagsOptions, setReloadTags } = useAssistanceTags()
  const [selectedAssistToResolve, setSelectedAssistToResolve] = useState(null)
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [formOptions, setFormOptions] = useState([])
  const [afterResolveModal, setAfterResolveModal] = useState(false)
  const [openQuestions, setOpenQuestions] = useState(false)
  const [showButtonModalSteps, setShowButtonModalSteps] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingQuestions, setLoadingQuestions] = useState(false)
  const [loadingProcessImage, setLoadingProcessImage] = useState("")
  const [uploaded, setUploaded] = useState("")
  const [assistanceId, setAssistanceId] = useState("")
  const [formSubmissionId, setFormSubmissionId] = useState("")
  const [formQuestionOptions, setFormQuestionOptions] = useState([])
  const [selectedRow, setSelectedRow] = useState("")
  const [selectedAssistance, setSelectedAssistance] = useState([])
  const [formSteps, setSteps] = useState([])
  const [formStepsAssistance, setFormStepsAssistance] = useState([])
  const [value, setValue] = useState({})
  const [searchTagValue, setSearchTagValue] = useState("")
  const [valuesQuestions, setValuesQuestions] = useState({})
  const [valuesQuestionsSaved, setValuesQuestionsSaved] = useState({})
  const [allQuestions, setAllQuestions] = useState([])
  const [evidenceType, setEvidenceType] = useState({})
  const [uploadedFiles, setUploadFile] = useState({})
  const [nextDateValues, setNextDateValues] = useState({
    nextDate: null,
    description: "",
  })
  const [selectedStep, setSelectStep] = useState()
  const [pendingAssistance, setPendingAssistance] = useState(false)
  const [tagsToAdd, setTagsToAdd] = useState([])
  const [tags, setTags] = useState([])
  const [tagsToRemove, setTagsToRemove] = useState([])
  const [evaluationModal, setEvaluationModal] = useState(false);

  const inputData =
    formStepsAssistance &&
    selectedStep &&
    formStepsAssistance.find((item) => item.id === selectedStep?.value)

  const {
    register,
    control,
    setValue: setValueForm,
    getValues,
    unregister,
    reset
  } = useForm({
    mode: 'onChange'
  })

  const loadAssistanceDetails = async (assistanceId) => {
    try {
      setLoadingQuestions(true)
      const response = await Send.get(`/assistance-to-resolve/assistance-steps/${assistanceId}`)

      setFormStepsAssistance(response)

      let newAllQuestions = []
      response.map((item) => {
        newAllQuestions = [...newAllQuestions, ...item.fields]
      })

      setAllQuestions(newAllQuestions)

      const stepsForm = response.map(({ id, title }) => ({ value: id, label: title }))
      setSteps(stepsForm)
      setSelectStep(stepsForm[0])
      setLoadingQuestions(false)
    } catch (error) {
      console.log("Erro ao buscar etapas do atendimento.", error)
      customToast("Erro ao buscar etapas do atendimento.", 'error')
    }

    setModalIsOpen(true)
  }

  const loadtagsToAdd = async () => {
    const response = await Send.get(
      `/tags-assistance-link/assistance/${selectedAssistToResolve?.id}`,
    )
    setTags(response.map(({ id, tag }) => ({ value: id, label: tag })))
  }

  useEffect(() => {
    if (assistanceId) {
      loadAssistanceDetails(assistanceId)
      loadtagsToAdd()
    }
  }, [assistanceId])

  useEffect(() => {
    getDefaultData(setDefaultData(inputData), valuesQuestions, reset)
  }, [selectedStep && inputData])

  useEffect(() => {
    if (selectedRow) {
      const completedItem = dataResolve.find((item) => item.id === selectedRow)
      setAssistanceId(completedItem?.assistanceId)
      setFormSubmissionId(completedItem?.formSubmissionId || null)
      setSelectedAssistToResolve({
        id: completedItem?.id,
        description: completedItem?.description,
        tags: completedItem?.tags,
      })
      showQuestions()
      setSelectedAssistance([])
    }
  }, [selectedRow])

  useEffect(() => {
    if (formsByProject && Array.isArray(formsByProject)) {
      const newFormOptions = formsByProject.map((form) => ({ label: form?.title, value: form?.id }))
      setFormOptions(newFormOptions)
    }

    return () => setFormOptions([])
  }, [formsByProject])

  useEffect(() => {
    if (Object.keys(valuesQuestions)?.length) {
      keepDataSavedOnChange()
    }
  }, [valuesQuestions])


  const goBack = (isNavigation = false) => {
    if (!isNavigation) {
      onCloseModal()
      setOpenQuestions(false)
      reset()
      setValuesQuestions({})
      setSelectedAssistToResolve(null)
      setSelectedRow("")
      typeof setReload === "function" && setReload(true)
    } else {
      navigate("/")
      reset()
      setValuesQuestions({})
      onCloseModal()
      typeof setReload === "function" && setReload(true)
    }
  }

  const updateStateRoute = (dataResolve, id) => {
    if (dataResolve && dataResolve?.length > 0) {
      navigate({},
        {
          replace: true,
          state: {
            dataResolve: dataResolve?.filter((item) => item?.id !== id),
          },
        },
      )
    }
  }

  const showQuestions = () => {
    setOpenQuestions(true)
    setSelectStep(formSteps[0])
  }

  const onChange = (e) => {
    setValue(e)
  }

  const onCloseModal = () => {
    setModalIsOpen(false)
    setValuesQuestions({})
    setSelectedRow("")
    setSteps([])
    setShowButtonModalSteps(false)
    setAssistanceId("")
    setUploadFile("")
    setUploaded("")
    setTags(null)
    setTagsToAdd([])
    setTagsToRemove([])
    setPendingAssistance(false)
    unregister()
    reset()
  }

  const onChangeQuestionsInfo = (name, values, formQuestionId, formQuestion) => {
    if (name === "select" && (formQuestion.typeIsMulti == "multiple" && formQuestion.isMulti == 'true')) {
      let formattedValue = Array.isArray(values) ?
        [...new Set(values.map((value) => `${value.label}`))]
        : values;

      formattedValue = Array.isArray(formattedValue)
        ? formattedValue.map((value, idx) => {
          const isTheLastPosition = idx !== values.length - 1

          return isTheLastPosition ? `${value}|` : value;
        })
        : values

      formattedValue = formattedValue ? formattedValue.toString().replaceAll("|,", "|") : '';

      setValuesQuestions({
        ...valuesQuestions,
        [formQuestionId]: !formattedValue || formattedValue === "" ? "Ø" : formattedValue,
      })

      return
    }

    if (name === "radio" || name === "checkbox" || name === "users" || name === "select" && formQuestion.typeIsMulti !== "multiple" && formQuestion.isMulti !== 'true') {

      const formattedData = Array.isArray(values)
        ? values?.map((row) => row.label).join("|")
        : values?.label

      setValuesQuestions({
        ...valuesQuestions,
        [formQuestionId]: formattedData || "",
      })

      return
    }

    setValuesQuestions({
      ...valuesQuestions,
      [formQuestionId]: values,
    })
  }

  const processFile = async (file) => {
    try {
      const base64 = await blobToBase64(file)
      return sendFileToFirebase(base64, file)
    } catch (error) {
      console.error("Erro ao processar arquivo:", error)
      throw error
    }
  }

  const onChangeFile = async (e, questionId, existingFiles = []) => {
    const chosenFiles = Array.from(e.target.files)

    if (e.target?.remove) {
      setUploadFile({
        ...uploadedFiles,
        [questionId]: null,
      })
      return
    }

    try {
      setLoadingProcessImage(questionId)

      const processedFiles = await Promise.all(chosenFiles.map(processFile))
      const uniqueFiles = [...new Set(processedFiles), ...existingFiles]
      const formattedValue = uniqueFiles.join("|")

      setUploadFile({
        ...uploadedFiles,
        [questionId]: formattedValue,
      })

      setUploaded(questionId)
      customToast("Arquivos enviados com sucesso", "success")
    } catch (error) {
      customToast("Erro ao fazer upload dos arquivos", "error")
    } finally {
      setLoadingProcessImage("")
      e.target.value = null
    }
  }

  const saveFormSubmission = async () => {
    if (
      nextDateValues.nextDate ||
      nextDateValues.description ||
      (nextDateValues.forms && nextDateValues.forms.length)
    ) {
      if (!nextDateValues.forms || nextDateValues.forms.length === 0) {
        customToast("Você deve selecionar ao menos um formulário.", "error")
        return
      }

      if (nextDateValues.forms.length && !nextDateValues.nextDate) {
        customToast(
          `Você selecionou ${nextDateValues.forms.length} formulário(s), preencha a data.`,
          "error",
        )
        return
      }

      if (nextDateValues.description && !nextDateValues.nextDate) {
        customToast("Você fez uma observação, preencha a data.", "error")
        return
      }
    }

    const mergeFileLinksWithQuestions = { ...uploadedFiles, ...valuesQuestions }

    setLoading(true)

    const normalizeAnswers = (answer) => {
      return typeof answer === 'object' && answer !== null
        ? answer.value
        : answer
    }

    try {
      const formattedData = allQuestions
        .map((formQuestion) => {

          if (
            mergeFileLinksWithQuestions[formQuestion.id] ||
            mergeFileLinksWithQuestions[formQuestion.id] === "0" || mergeFileLinksWithQuestions[formQuestion.id] === ""
          ) {

            const updateId = formQuestion?.filledData ? { id: formQuestion?.filledData?.id } : {}

            return {
              formSubmission: formSubmissionId,
              formQuestion: formQuestion.id,
              value: normalizeAnswers(mergeFileLinksWithQuestions[formQuestion.id]) || "",
              ...updateId
            }
          }
        })
        .filter((item) => item)

      const response = await Send.post(
        `/assistance-to-resolve/finish/${selectedAssistToResolve?.id}`,
        {
          contentToSave: formattedData,
          newAssistanceToResolve: nextDateValues.nextDate ? nextDateValues : {},
          tagsToAdd,
          tagsToRemove,
          userId: user?.user?.id,
          projectId: scope?.id,
          isPending: pendingAssistance,
        },
      )

      if (response.status === "error") throw new Error("Erro ao finalizar atendimento.")

      customToast("Atendimento resolvido", "success")
      console.log({ dataResolve })
      setEvaluationModal(dataResolve.find(row => row.id === selectedRow)?.assistanceUserIds);
      updateStateRoute(location?.state?.dataResolve, selectedAssistToResolve?.id)
      handleCloseNextEvent()
      goBack()
    } catch (error) {
      console.log("Erro ao finalizar atendimento", "error")
      customToast(error.message, "error")
    }

    setLoading(false)
  }

  const handleChangeNextDate = (name, value) => {
    setNextDateValues({ ...nextDateValues, [name]: value })
  }

  const handleChangeTags = (newValue, actionMeta) => {
    const { action } = actionMeta

    const handleCreateOption = (newValue) => {
      const newValues = newValue.map(({ __isNew__, ...rest }) => rest)
      const tagsToAdd = newValues.map(({ value, label }) => ({ name: label, id: value }))
      setTagsToAdd(tagsToAdd)
    }

    const handleRemoveValue = (newValue, tags) => {
      const removedTags = tags.filter((tag) => !newValue.some((nv) => nv?.value === tag?.value))
      const tagsToRemove = removedTags.map(({ value, label }) => ({ name: label, id: value }))
      setTagsToRemove(tagsToRemove)
    }

    if (action === "create-option") {
      handleCreateOption(newValue)
    } else if (action === "remove-value") {
      handleRemoveValue(newValue, tags)
    } else {
      const tagsToAdd = newValue.map(({ value, label }) => ({ name: label, id: value }))
      setTagsToAdd(tagsToAdd)
    }
  }

  const handleSelectedAssistance = (current) => {
    setSelectedAssistance(current)
  }

  const handleOpenNextEvent = () => {
    customToast("Para salvar, preencha as informações do próximo atendimento.", "info")
    setAfterResolveModal(true)
  }

  const handleCloseNextEvent = () => {
    setAfterResolveModal(false)
  }

  const keepDataSavedOnChange = () => {
    if (!formStepsAssistance || !selectedStep) {
      return
    }

    const selectedStepId = selectedStep.value
    const formQuestionsOptions = formStepsAssistance.find((item) => item.id === selectedStepId)

    if (!formQuestionsOptions) {
      return
    }

    const fieldTitles = formQuestionsOptions.fields.map((item) => item.title)

    const valuesToSet = Object.fromEntries(
      Object.entries(getValues()).filter(
        ([key, value]) => fieldTitles.includes(key) && value?.length,
      ),
    )

    setValuesQuestionsSaved(valuesToSet)
    setFormQuestionOptions(formQuestionsOptions.fields)

    Object.entries(valuesToSet).forEach(([key, value]) => {
      setValueForm(key, value)
    })
  }

  const onStepSelect = (step) => {
    setSelectStep(step)
    keepDataSavedOnChange()
  }

  const handleRemoveTag = async (tagLinkId) => {
    try {
      const response = await Send.delete(`/tags-assistance-link/${tagLinkId}`)
      if (response.status === "success") {
        customToast("Tag removida", "success")
        setReloadTags(true)

        if (selectedAssistToResolve && selectedAssistToResolve?.id) {
          setSelectedAssistToResolve({
            ...selectedAssistToResolve,
            tags: selectedAssistToResolve?.tags.filter((row) => row?.tagLink !== tagLinkId),
          })
        }
      }
    } catch (error) {
      console.log("Erro ao tentar remover tag", error)
      customToast("Erro ao tentar remover tag", "error")
    }
  }

  const removeFile = () => {
    setUploaded(false)
    setUploadFile("")
  }

  const handlePendingAssistance = (e) => {
    setPendingAssistance(e.target.checked)
  }

  const handleSearchTagChange = (currentValue) => {
    setSearchTagValue(currentValue)
  }

  const handleApplyFilter = (oldData) => {
    let newFilteredData = oldData

    if (searchTagValue && searchTagValue.length) {
      newFilteredData = newFilteredData.filter((row) =>
        row.tags.find((item) => searchTagValue.map((tag) => tag.value).includes(item.id)),
      )
    }

    return newFilteredData || []
  }

  const formattedMulti = (values) => {
    return Array.isArray(values) ?
      values.map((row, idx) => {
        const answerExists = values.slice(0, idx).find(item => item.value === row.value);

        if (answerExists)
          return null;

        return row
      }).filter(row => row)
      : values;
  }

  const handleSendEvaluation = async () => {
    try {
      const response = await Send.post('/message/serviceEvaluation', { assistanceUserIds: evaluationModal });

      customToast('Avaliação enviada com sucesso', 'success');
    } catch (error) {
      console.log("Erro ao enviar avaliação", error);
      customToast('Erro ao enviar avaliação', 'error');
    }

    setEvaluationModal(false);
  }

  console.log("FORMSTEPS", inputData)

  return (
    <>
      <AssistanceToResolveScreen
        {...{
          selectedAssistance,
          setReload,
          values: formattedMulti(getValues()),
          dataResolve: handleApplyFilter(dataResolve),
          loadingDataToResolve,
          handleSearchTagChange,
          searchTagValue,
          handleSelectedAssistance,
          modalIsOpen,
          setModalIsOpen,
          loading,
          formQuestionOptions,
          users,
          openQuestions,
          goBack,
          formSteps,
          formStepsAssistance,
          onChange,
          onChangeQuestionsInfo,
          value,
          onCloseModal,
          selectedRow,
          setSelectedRow,
          showButtonModalSteps,
          showQuestions,
          saveFormSubmission,
          selectedDescription: selectedAssistToResolve?.description ?? "",
          currentRowData: selectedAssistToResolve,
          afterResolveModal,
          handleOpenNextEvent,
          handleCloseNextEvent,
          nextDateValues,
          handleChangeNextDate,
          handleChangeTags,
          valuesQuestions,
          valuesQuestionsSaved,
          onChangeFile,
          uploaded,
          uploadedFiles,
          evidenceType,
          removeFile,
          loadingProcessImage,
          formOptions,
          onStepSelect,
          selectedStep,
          control,
          register,
          loadingQuestions,
          tags,
          handleRemoveTag,
          pendingAssistance,
          setPendingAssistance,
          handlePendingAssistance,
          tagsOptions,
          inputData,
          evaluationModal,
          handleSendEvaluation
        }}
      />
    </>
  )
}

export default AssistanceToResolveContainer
